export default "__VITE_ASSET__BW0C1YXs__"